import React from 'react';
import PropTypes from 'prop-types';
import EJMatchGateway from '../EJMatchGateway/EJMatchGateway';
import DownloadSendConnect from '../DownloadSendConnect/DownloadSendConnect';
import '../../pages/Results/Results.scss';
import './ResultsGreeting.scss';

const ResultsGreeting = ({
  // eslint-disable-next-line no-unused-vars
  downloadingPdf,
  setDownloadingPdf,
  showFindFa,
  showCaFindFa,
  showSendToFa,
  sendingPdfToFa,
  setSendingPdfToFa,
  setResultsSentToFa,
  sendResultsButtonDisabled,
  resultsToSendToDelegator,
  setNotificationContent,
  setNotificationOpen,
  query,
  sessionId,
  coldContactData,
  setColdContactData,
  faInfo,
  contactName,
  userComments,
  setUserComments,
  isWebProspect
}) => {
  const showEJMatchGateway = showFindFa && !showCaFindFa;

  return (
    <>
      {showEJMatchGateway && (
        <EJMatchGateway
          downloadingPdf={downloadingPdf}
          setDownloadingPdf={setDownloadingPdf}
          showFindFa={showFindFa}
          showSendToFa={showSendToFa}
          sendingPdfToFa={sendingPdfToFa}
          setSendingPdfToFa={setSendingPdfToFa}
          setResultsSentToFa={setResultsSentToFa}
          sendResultsButtonDisabled={sendResultsButtonDisabled}
          resultsToSendToDelegator={resultsToSendToDelegator}
          setNotificationContent={setNotificationContent}
          setNotificationOpen={setNotificationOpen}
          query={query}
          sessionId={sessionId}
          coldContactData={coldContactData}
          setColdContactData={setColdContactData}
          faInfo={faInfo}
          contactName={contactName}
          userComments={userComments}
          setUserComments={setUserComments}
          isWebProspect={isWebProspect}
        />
      )}
      {!showEJMatchGateway && (
        <DownloadSendConnect
          downloadingPdf={downloadingPdf}
          setDownloadingPdf={setDownloadingPdf}
          showFindFa={showFindFa}
          showCaFindFa={showCaFindFa}
          showSendToFa={showSendToFa}
          sendingPdfToFa={sendingPdfToFa}
          setSendingPdfToFa={setSendingPdfToFa}
          setResultsSentToFa={setResultsSentToFa}
          sendResultsButtonDisabled={sendResultsButtonDisabled}
          resultsToSendToDelegator={resultsToSendToDelegator}
          setNotificationContent={setNotificationContent}
          setNotificationOpen={setNotificationOpen}
          query={query}
          sessionId={sessionId}
          coldContactData={coldContactData}
          setColdContactData={setColdContactData}
          faInfo={faInfo}
          contactName={contactName}
          userComments={userComments}
          setUserComments={setUserComments}
        />
      )}
    </>
  );
};

ResultsGreeting.propTypes = {
  downloadingPdf: PropTypes.bool.isRequired,
  showFindFa: PropTypes.bool.isRequired,
  showCaFindFa: PropTypes.bool,
  showSendToFa: PropTypes.bool.isRequired,
  sendingPdfToFa: PropTypes.bool.isRequired,
  sendResultsButtonDisabled: PropTypes.bool.isRequired,
  setSendingPdfToFa: PropTypes.func.isRequired,
  setDownloadingPdf: PropTypes.func.isRequired,
  setResultsSentToFa: PropTypes.func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  resultsToSendToDelegator: PropTypes.object.isRequired,
  setNotificationContent: PropTypes.func.isRequired,
  setNotificationOpen: PropTypes.func.isRequired,
  query: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  sessionId: PropTypes.string.isRequired,
  coldContactData: PropTypes.objectOf(PropTypes.string),
  setColdContactData: PropTypes.func.isRequired,
  faInfo: PropTypes.objectOf(PropTypes.string).isRequired,
  contactName: PropTypes.objectOf(PropTypes.string),
  userComments: PropTypes.string,
  setUserComments: PropTypes.func.isRequired,
  isWebProspect: PropTypes.bool.isRequired
};
ResultsGreeting.defaultProps = {
  coldContactData: {},
  contactName: {},
  userComments: '',
  showCaFindFa: false,
};
export default ResultsGreeting;
